import { Theme } from '@mui/material';

export const sxStyles = {
  filterOption: {
    alignItems: 'flex-start',
    width: '100%',
    marginRight: 0,
    contain: 'inline-size',
  },
  filterOptionLabel: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingTop: '0.5rem',
  },
  filterOptionTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.375rem',
    fontWeight: 600,
  },
  filterOptionCount: (theme: Theme) => ({
    marginLeft: 'auto',
    color: theme.palette.text.secondary,
  }),
  filterOptionSubtitle: (theme: Theme) => ({
    color: theme.palette.text.secondary,
  }),
  notice: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '1rem',
    color: theme.palette.text.secondary,
  }),
  icon: {
    display: 'inline-flex',
    flexShrink: 0,
  },
};
